
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SignaturePadModule } from 'angular2-signaturepad';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ClientOnboardinglistComponent } from './client-onboardinglist.component';
import { ClientOnboardingListRoutingModule } from './client-onboardinglist-routing.module';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { clientOnboardingModule } from '../client-onboarding/client-onboarding.module';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { ClientEmployeeDynamicFormModule } from '../client-employee-dynamicform/client-employee-dynamicform.module';


@NgModule({
  imports: [
    ClientOnboardingListRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MyDatePickerModule,
    clientOnboardingModule,
    PDFExportModule,
    NgxUiLoaderModule,
    GridModule,
    MaskedTextBoxModule,
    ClientEmployeeDynamicFormModule,
  ],
  declarations: [
    ClientOnboardinglistComponent,    
  ],
  exports:[ ClientOnboardinglistComponent],
  schemas:[NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA]

})
export class clientOnboardingListModule { }